import { HttpResponse } from '@angular/common/http';

/**
 * Saves a blob response as a file, named from the server's own `Content-Disposition` header when
 * present — the backend already sanitises that name, so there is nothing to parse defensively here
 * beyond the regex not matching.
 */
export function triggerBlobDownload(response: HttpResponse<Blob>, fallbackFilename: string): void {
  const blob = response.body;
  if (!blob) {
    return;
  }

  const disposition = response.headers.get('Content-Disposition') ?? '';
  const filename = /filename="([^"]+)"/i.exec(disposition)?.[1] ?? fallbackFilename;

  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
